// extracted by mini-css-extract-plugin
export default {"trigger":"ImageModal_trigger__V+4dl","image":"ImageModal_image__IE+hc"};